import { inject } from '@angular/core'

import { Observable, first, map } from 'rxjs'

import { FlxModalService } from '@flowx/angular-ui-toolkit'
import { DependenciesPageComponent } from '@flowx/designer/modules/dependencies/components/dependencies-page/dependencies-page.component'
import { ConfirmationModalComponent } from '@flowx/designer/shared/components/confirmation-modal/confirmation-modal.component'

export const dependenciesCanDeactivate = (
  component: DependenciesPageComponent
): Observable<boolean> | boolean => {
  const dependenciesTabIsPristine = !component.dependenciesTabEditingEnabled()
  const overridesTabIsPristine = !component.overridesTabPayload()

  if (dependenciesTabIsPristine && overridesTabIsPristine) {
    return true
  } else {
    const modalService = inject(FlxModalService)

    return modalService
      .show(
        ConfirmationModalComponent,
        { closeOnBackdropClick: false, backdropClass: 'overlay-backdrop' },
        {
          title: `Changes Unsaved`,
          message: `You have unsaved changes. Are you sure you want to exit page?`,
          btnOkText: `Discard Changes`,
          modalClass: 'pending-changes',
        }
      )
      .data$.pipe(
        first(),
        map(({ confirm }) => confirm)
      )
  }
}
